var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "container",
      staticClass: "k-title-container",
      attrs: { "data-cy": _vm.column.downloadable ? "" : "non-downloadable" }
    },
    [
      _c(
        "v-tooltip",
        {
          attrs: { top: "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function(ref) {
                var on = ref.on
                var attr = ref.attr
                return [
                  _c(
                    "div",
                    _vm._g(
                      _vm._b(
                        { staticClass: "k-title-text" },
                        "div",
                        attr,
                        false
                      ),
                      _vm.hasTooltip ? on : undefined
                    ),
                    [_c("span", [_vm._v(_vm._s(_vm.title))])]
                  )
                ]
              }
            }
          ])
        },
        [
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.column.tooltip || _vm.title))])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _vm.showSortBtn
            ? _c(
                "v-btn",
                {
                  class: _vm.sortingClass,
                  attrs: { flat: "", small: "", disabled: _vm.disabled },
                  on: { click: _vm.handleSortClick }
                },
                [
                  _c(
                    "div",
                    { staticClass: "k-sort-btn-content" },
                    [
                      _c("span", { staticClass: "k-sort-title-content" }, [
                        _vm._v(_vm._s(_vm.sortText))
                      ]),
                      _vm._v(" "),
                      _c("v-icon", { class: _vm.iconClass }, [
                        _vm._v("straight")
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.sortCount))])
                    ],
                    1
                  )
                ]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }